export const instanceId = (index: number, instance: any): string => instance.id;
